/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'fill-quote': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _stroke="none" stroke-width="1" _fill="none" fill-rule="evenodd"><g transform="translate(9 6)" fill-rule="nonzero"><path pid="0" d="M10.294 4.75h3.212a.206.206 0 00.19-.122.192.192 0 00-.044-.216L9.41.338a.212.212 0 00-.223-.044.198.198 0 00-.128.181v3.087c0 .656.553 1.188 1.235 1.188z" _fill="#FFF"/><path pid="1" d="M2.059 13.557h-.515a.202.202 0 00-.206.198v.99c0 .11.092.198.206.198h.515c.398 0 .72-.31.72-.693a.707.707 0 00-.72-.693z" _fill="#000"/><path pid="2" d="M14 5.74a.202.202 0 00-.206-.198h-3.5c-1.137 0-2.059-.886-2.059-1.98V.199A.202.202 0 008.03 0H1.647C.737 0 0 .709 0 1.583v15.834C0 18.29.737 19 1.647 19h10.706c.91 0 1.647-.709 1.647-1.583V5.74z" _fill="#FFF"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/fill-quote.js